import { Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";

export const UserAgreement = () => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" sx={{}}>
      <Box p="40px 95px 50px" width="1280px">
        <Typography variant="bold" fontSize="30px" color="primary">
          User Agreement
        </Typography>

        <Typography fontSize="16px" color="secondary" mt="30px">
          This User Service Agreement (“Agreement”) is made by and between you
          and Wepos Technology Limited (“Company” or “Wepos”), shall be an
          effective Agreement.
          <br />
          <br />
          Wepos, a corporation duly is establishing under the laws of the
          British Virgin Islands, is the developer and operator of Wetez, an
          Application with the function of a digital-asset wallet
          (“Application”), and is engaged by users to provide node services on
          POS (Proof of Stake) public blockchain (“Service”)
          <br />
          <br />
          In this Agreement, “us”, “we”, “our” and “Wepos” means Wepos
          Technology Limited, its owners, directors, investors, employees,
          affiliated parties, related bodies corporate or other related parties.
          “Wepos” may also refer to the services, products, website, content or
          other materials provided by Wepos as the context requires.
          <br />
          <br />
          The website (www.wetez.io and www.wetez.cn ) is owned and operated by
          Wepos. By accessing to our website and downloading our Application,
          and further by registering to use our Service, you agree to accept any
          and all terms and conditions herein published by the Company. You
          should read our disclaimer and other terms and conditions carefully
          and immediately cease using our Application and Service if you do not
          agree with any terms.
          <br />
          <br />
          We solemnly remind that: any entity or individual who access to our
          website, Application or Service is deemed to have fully understood,
          acknowledged and accepted the entire contents of this Agreement. Wepos
          reserves the right to amend and interpret any and all contents of this
          Agreement, especially our disclaimer.
          <br />
          <br />
          Content and Execution
          <br />
          <br />
          1. This Agreement includes all rules already or will be published by
          Wepos (“Relevant Rules”). All Relevant Rules are an integral part of
          this Agreement and have the same legal effect as this Agreement.
          Except otherwise expressly stated, any products and services provided
          by Wepos will be bound by this Agreement.
          <br />
          <br />
          2. You must carefully read the full content of this Agreement before
          using our Application and Service. If you have any questions regarding
          this Agreement, you should consult us (E-mail:[support@wetez.io]).
          However, regardless of whether you have actually read this Agreement
          carefully before using our Application and Service, as long as you use
          the Application and Service, you will be deemed to be bound by this
          Agreement. You may not use the reasons of not having read this
          Agreement or not having received answers to inquiries from us as a
          basis to invalidate or cancel this Agreement. 
          <br />
          <br />
          3. Wepos has the right to amend this Agreement and/or any Relevant
          Rules at any time according to its needs. The amended and restated
          terms will be informed on the Application and you will not be notified
          individually. The amended and restated Agreement and/or Relevant Rules
          will automatically take effect once it is informed on the Application.
          If you do not agree with the changes, you must cease use of the
          Application and Service immediately. Your continued use of the
          Application or Service shall be deemed as your acceptance of the
          amended terms and conditions and/or Relevant Rules. Please check this
          Agreement from time to time to take notice of any changes we made, as
          they are binding on you.
          <br />
          <br />
          4. For certain other products or services provided by Wepos,
          additional terms and conditions may apply. If you want to access to
          such products or services, you need to agree to the relevant terms and
          conditions applicable to those products or services. In case of any
          inconsistency between such terms and conditions and this Agreement,
          those terms and conditions will prevail.
          <br />
          <br />
          User and Wallet
          <br />
          <br />
          1. Eligibility of Users
          <br />
          <br />
          By using the Application and Service in a manner allowed by Wepos, you
          acknowledge that you must be:
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(a) a natural person of at least 18
          years of age, a legal person, or other entity;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(b) has full legal right and ability to
          enter into a legally binding Agreement with us;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(c) agree and warrant to use the
          Application and Service in accordance with this Agreement; <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(d) is seasoned in blockchain,
          distributed ledger technology and digital assets and has been well
          aware of all the risks; and
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(e) an accredited investor in
          accordance with applicable laws and regulations, if any.
          <br />
          <br />
          If you do not meet these eligibility requirements, you must bear all
          resulting consequences, and Wepos has the right to make claims against
          you. 
          <br />
          <br />
          2. User Information  <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(a) When using the Application and
          Service, you should update your user information from time to time to
          comply with related laws and regulations and ensure it remains true,
          updated, complete and accurate. Without such information, you may not
          be able to use certain services. Wepos does not assume any
          responsibility in this respect, and you are liable for any resulting
          direct or indirect losses and adverse consequences. 
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(b) You must accurately fill in and
          update the contact information you provide to Wepos such as email
          address, contact number, address etc., in order for Wepos to
          effectively contact you if necessary. If you cannot be contacted by
          such contact information, you are solely responsible for any resulting
          losses or costs incurred while using the Application and Service.{" "}
          <br />
          <br />
          3. Create or Import Wallet
          <br />
          <br />
          Create or import wallet: when you first use our Application on your
          mobile device, you can create and/or import wallet, set wallet
          password and use your wallet on Application to transfer and receive
          digital assets on blockchain.
          <br />
          <br />
          4. Wallet Safety
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(a) You are solely responsible for the
          confidentiality of your wallet address and password, and all
          activities that occur under your wallet address and password
          (including, but not limited to, disclosure or release of information,
          transfer or store digital assets, or using services online etc.) You
          agree:
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(i) to
          immediately inform us and authorize Wepos in the event that you
          discover any unauthorized usage of your login name and password or any
          other situation that violates the confidentiality provisions between
          you and Wepos; and 
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(ii) to
          correctly use the Application and Service. We cannot and will not take
          responsibility for any losses or damages that are incurred as a result
          of your failure to comply with this provision. <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(b) In order to keep the
          decentralization feature of blockchain and to protect the security of
          your digital assets, Wepos may not be able to provide a centralized
          service. You acknowledge and accept that the Company SHALL NOT have
          any obligation or responsibility to :<br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(i) store
          users’ wallet password (the password users set when creating or
          importing wallets), private key or mnemonic words;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(ii) recover
          users’ wallet password, private key or mnemonic words;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(iii) freeze
          the wallet;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(iv) report the
          loss of wallet;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(v) recover the
          wallet; or
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(vi) rollback
          transactions.
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(c) After you create or import wallet
          on the Application, your wallet password, private key and mnemonic
          words will not be stored in the Application or on the servers of
          Wepos. You would better to back up your wallet address, password,
          private key and mnemonic words when you create or import wallet by
          writing them down on papers or backup them in password management
          applications. <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(d) You shall bear sole responsibility
          to take care of your mobile devices, wallet password, private key and
          mnemonic words. Company does not store or hold the above information
          for users. You shall be solely responsible for any risks, liabilities,
          losses and expenses which result from frauds, you losing your mobile
          device, disclosing (whether actively or passively) or forgetting
          wallet password, private key, mnemonic words or keystore, or your
          wallet being attacked.
          <br />
          <br />
          Use of Application and Service  <br />
          <br />
          1. Version of Application
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(a) Company may develop different
          versions of Application for different terminal devices. You shall
          download and install applicable version. If you download and install
          Application or other applications with the same name from any
          unauthorized third party, Company cannot guarantee the normal
          operation or security of such application. Any loss caused by using
          such application shall be borne solely by you.
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(b) A previous version of Application
          may stop to operate after a new version is released. Company cannot
          guarantee the security, continuous operation or customer services for
          the previous version. Users shall download and use the latest version.
          <br />
          <br />
          2. During your use of the Application and Service, you undertake to
          comply with the following provisions: 
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(a) All acts conducting during use of
          the Application and Service must comply with all applicable national
          laws, regulations, rules and requirements, must not violate social
          public interest or public morals, must not adversely affect the
          legitimate rights and interests of others, and must not violate this
          Agreement as well as the Relevant Rules. If you violate any of the
          above undertakings, and the violation results in any legal
          consequences, you must individually bear all legal responsibilities
          and ensure that Wepos is exempt from any resulting losses.  
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(b) To act in good faith, not to
          undertake any behavior of unfair competition, not to disturb the
          normal order, and not to engage in actions unrelated to the purpose of
          using the Application and Service.
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(c) Not to commercially use any data of
          Wepos, including but not limited to, to not copy or disseminate etc.
          and use any information without the prior written consent of Wepos. 
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(d) Not to use any devices, software or
          routine procedures to interfere or attempt to interfere with the
          normal operation of Wepos’s Application and Service. You must not
          carry out any action that will cause a large data load to the network
          system of our servers.  <br />
          <br />
          3. You understand and agree that: <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(a) Wepos has the right to unilaterally
          decide whether you have violated any of the aforementioned
          undertakings, and to carry out any measures or terminate your use of
          the Application and Service in accordance with the Relevant Rules
          without your consent or prior notice to you.
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(b) Where any legal document made
          effective by the administrative or judicial authorities of any country
          confirms that you have performed an illegal or infringing act, or
          where Wepos unilaterally determines that your actions may violate the
          provisions of this Agreement and/or the Relevant Rules or may violate
          any applicable laws and regulations, Wepos has the right to publicize
          such illegal acts or violations of contract and the measures that
          Wepos has taken against you. 
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(c) Regarding your actions, including
          actions that have not yet been carried out but has already affected
          Wepos and other users, Wepos has the right to unilaterally determine
          the nature of your action and whether it constitutes a violation of
          this Agreement and/or the Relevant Rules, and carry out corresponding
          enforcement actions. You must retain all evidence related to your
          actions, and bear the consequences of not having sufficient evidence. 
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(d) You must individually bear all
          legal liabilities arising from the damages caused to any third party
          caused by possible violations of this Agreement, and ensure that Wepos
          is exempt from any resulting losses or costs. 
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(e) If Wepos suffers from any loss, or
          is subject to any third-party claims, or is penalized by any
          government department as a result of your violations of any relevant
          laws, this Agreement or any Relevant Rules, you must compensate Wepos
          for the losses and/or costs incurred, including reasonable attorney
          fees.  
          <br />
          <br />
          4. Service Fee
          <br />
          <br />
          Joining Wepos and registration is free, however, we may charge a fee
          for some contents of the Service. We may adjust the service charge and
          its rate according to operating conditions as well as the mechanism of
          POS public blockchain. Where practicable, we will notify you of any
          applicable fee or rate at which fees are to be paid as soon as the
          modification is made and will update you from time to time if there
          are any revisions to any fees.
          <br />
          <br />
          5. Time <br />
          <br />
          Wepos may use a certain amount of digital assets that you provide to
          us as deposit in order for earning some digital assets by using our
          Application or Service. There may be a certain locking period of
          deposit and verification period of earnings according to the specific
          mechanism of different POS public blockchains. Thus, the actual time
          of refunding deposit and releasing earnings may not be certain and
          will be determined eventually by Wepos in accordance with the
          mechanism of different POS public blockchains.
          <br />
          <br />
          6. Earnings <br />
          <br />
          The service charge and its rate depend on the amount of earning
          digital assets received from POS public blockchains. The amount and
          period of earning digital assets we made will depend on the specific
          mechanism of POS public blockchains. The earnings may do not reach
          your expectations, or there may be no any earnings in the worst case
          due to instability of POS public blockchain.
          <br />
          <br />
          Special Authorization
          <br />
          <br />
          You fully understand and irrevocably grant the following rights to us:
          <br />
          <br />
          1. Once you have made an undertaking in any form to Wepos, and we have
          confirmed your violation of such undertaking, Wepos has the right to
          impose restriction on you in accordance with your undertaking or
          measures agreed in this Agreement, including the suspension and
          termination of your use of the Application and Service, and to
          publicize the violation confirmed by us. You understand and agree that
          Wepos is not required to verify such confirmation with you, or to
          obtain your consent, and Wepos will not bear any responsibility for
          the restriction measures or publications taken against you. 
          <br />
          <br />
          2. Once you violate this Agreement or any Relevant Rules, or other
          agreements made with relevant parties, Wepos has the right to notify
          relevant parties in any manner, and request them to impose
          restrictions on you, including but are not limited to suspend or
          terminate the products and services provided to you (in part or in
          full), or to publicize your violation on any website that it operates
          or effectively controls etc.    
          <br />
          <br />
          3. You grant Wepos an exclusive, worldwide, perpetual, sub-licensable
          and free right to use any information or data you have provided. In
          addition, Wepos has the right (fully or partially) to use, copy,
          revise, edit, publish, translate, disseminate, execute and display all
          of your information and data (including but not limited to,
          registration information, transaction data, and various types of
          information), or create derivative works, and use any form, media or
          technology currently known or developed in the future to incorporate
          such data or information in other works. 
          <br />
          <br />
          Representations and Warranties <br />
          <br />
          1. Users agree and acknowledge that：
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(a) you will only use the Application
          and Service for the purposes of and in accordance with this Agreement;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(b) you are duly authorized and have
          full capacity to use the Application and Service;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(c) you will be fully responsible for
          any content related to the Application and Service including any text,
          file, image, photo, video, audio, music and any other information that
          you uploaded, posted, spread, and sent (including communications by
          e-mail) on any websites.
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(d) you will comply with all applicable
          laws in any jurisdiction in which or from which you seek to operate
          your wallet;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(e) all digital assets deposited into
          your wallet comes from legal sources which you own or otherwise have
          full legal authority to deal with; <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(f) you acknowledge that you understand
          and accept the risks involved in using the Application and Service
          provided by us;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(g) your use of the Application and
          Service does not infringe the rights of any third party or any
          applicable law;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(h) you are responsible for any
          activities by using the Application and Service;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(i) you are responsible for the
          accuracy and integrity of the information provided by you;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(j) you will not use the Application
          and Service to perform any illegal activity of any sort, including but
          not limited to illegal fundraising, money laundering or terrorism
          financing.
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(k) you acknowledge that our Service
          hinges heavily on the consensus mechanism of POS public blockchains.
          You are fully aware of the nature of blockchain and the way it works,
          and you agree that: <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(i) Wepos makes
          no warranty as to whether it will gain the earnings or the amount of
          earnings;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(ii) Wepos may
          adjust the contents and approaches of the Service from time to time
          according to its needs;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(iii) The
          release time of earnings is determined by Wepos based on specific
          mechanism of POS public blockchains;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(iv) The
          service charge and its rate may be adjusted from time to time
          according to operating conditions of Wepos as well as the mechanism of
          POS public blockchains.
          <br />
          <br />
          2. Wepos agrees and acknowledges that： <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(a) To the maximum extent permitted by
          law, we make no warranties or representations about any content of the
          Application and Service, including but not limited to warranties or
          representations that they will be complete, accurate, up-to-date or
          secure, that access will be uninterrupted or error-free or free from
          viruses.
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(b) We reserve the right to restrict,
          suspend or terminate your access to the Application and Service or any
          other content at any time without notice and we will not be
          responsible for any loss, cost, damage or liability that may arise as
          a result.
          <br />
          <br />
          Disclaimer <br />
          <br />
          1. Regulatory Measures <br />
          <br />
          Depending on your country or region of residence, you may not be able
          to use the Application and Service. You shall be obliged to abide by
          those rules and laws in your country of residence and/or country from
          which you access to our Application and Service. Furthermore, since
          regulatory policies could change from time to time, existing
          regulatory permission or tolerance in any jurisdiction could be just
          temporary. You should immediately cease using our Application and
          Service if you were not legally allowed or not meet the qualifications
          required by those rules and laws.
          <br />
          <br />
          2. Personal Information <br />
          <br />
          Wepos may need to carry out “know your customer” survey (“KYC”)
          subject to certain relevant requirements of applicable laws or
          regulations. We may request personal information (such as passport,
          driver’s license, identity card, government issued photographic
          identification, utility bills, banking account information, or
          similar) for the purpose of reducing money laundering and terrorism
          financing incidents. When using the Application and the Service, you
          should provide relevant information according to our requirements and
          update your information from time to time in order to ensure it
          remains true, updated, complete and accurate. If there are reasonable
          grounds to doubt that the information you provided is incorrect,
          false, outdated or incomplete, Wepos has the right to make an inquiry
          and/or request changes, and also has the right to directly delete any
          corresponding information, until the suspension or termination of the
          Service (in full or in part) provided to you. Wepos does not assume
          any responsibility in this respect, and you are liable for any
          resulting direct or indirect losses and adverse consequences.
          <br />
          <br />
          3. Popularity and Liquidity <br />
          <br />
          The digital assets involved in the Service are not a currency or asset
          issued by any individual, entity, central bank or national,
          supra-national or quasi-national organization, nor is it backed by any
          hard assets or other credit. The value of digital assets hinges
          heavily on the popularity of its project and depends on the consensus
          on its value between the relevant market participants. The worst-case
          scenario is that digital assets may even remain marginalized in a long
          term, appealing to only a minimal portion of the users. Wepos will not
          (nor has the obligation or responsibility to) stabilize or otherwise
          affect and make no guarantee about the market price of any digital
          assets.
          <br />
          <br />
          4. Price Volatility <br />
          <br />
          The participation in trades or other activities relating to digital
          assets involves significant risk which is not generally shared with
          official fiat currencies or goods or commodities in a market. Unlike
          most fiat currencies, these digital assets are based on technology and
          trust. There is no central bank or another entity that can take
          corrective measure to protect the value or manage the supply and
          demand of the digital assets during. The prices of digital assets may
          suffer a large fluctuation in value and may become worthless. Wepos
          will not (nor has the obligation or responsibility to) stabilize or
          otherwise affect and make no guarantee about any digital asset’s
          market price. You should carefully assess whether your objectives,
          financial situation, needs, experience and tolerance for risk is
          suitable for participating the trades or other activities relating to
          digital assets.
          <br />
          <br />
          5. Network Security <br />
          <br />
          We may collect and you are willing to provide a certain amount of
          digital assets to provide the Service, in accordance with the specific
          rules and mechanism of POS public blockchains. We highly recommend
          that you shall use the Application and Service in a secured network
          environment and please do not use a jailbreak or rooted mobile device.
          In spite of all reasonable effort will be taken by Wepos to keep such
          collected digital assets secure, there is still a great possibility of
          occurring a variety of cyberattacks or burglaries or other network
          security issues that will have adversely effects. This may
          consequently result in the loss of any digital assets held by Wepos or
          stored in other third-party blockchains. You are fully aware of and
          willing to accept all risks arising from cyberattacks, theft or any
          other network security issues. Furthermore, you shall make no claims
          against Wepos for any loss of digital assets that cannot be prevented
          or avoided by taking reasonable and necessary measures.
          <br />
          <br />
          6. Back-up
          <br />
          <br />
          You understand that after you create or import wallet on the
          Application, your wallet password, private key and mnemonic words will
          not be stored in the Application or on the servers of Wepos. We highly
          recommend that you back up your wallet address, password, private key
          and mnemonic words when you create or import wallet by writing them
          down on papers or backup them in password management applications. You
          may change another mobile device to use the Application after you
          follow the instructions of Wepos to back up your wallet. If (i) you
          lose your mobile device before you write down or backup your wallet
          address, password, private key or mnemonic words, or (ii) your wallet
          address, password, private key or mnemonic words is disclosed, or
          (iii) the device which stores or holds your wallet address, password,
          private key or mnemonic words is hacked or attacked, you may lose your
          digital assets and Wepos will not be able to recover them. Wepos will
          not be responsible for any and all losses arising in connection with
          the foregoing.
          <br />
          <br />
          7. Third-Party Applications <br />
          <br />
          Wepos may provide application interfaces to accommodate all kinds of
          external application that are developed by third parties, such as some
          third-party wallets or other external applications that a number of
          general-purpose private keys can be transferred to. All such external
          applications are beyond the control of Wepos. Wepos neither intends
          nor has authority to act as a censor to scrutinize to any extent any
          external applications. Therefore, you must carefully and cautiously
          access to and make use of any external third-party application in the
          use of the process. Wepos will not be responsible for any damages or
          losses caused by external third-party applications.
          <br />
          <br />
          8. Risk of POS Public Blockchains
          <br />
          <br />
          The Service provided by Wepos hinges heavily on the consensus
          mechanism of the POS public blockchains. Wepos reserves the right to
          adjust the contents and approaches of the Service including without
          limitation the commission rate, deposit rate and release time of
          earnings, from time to time in accordance with the different consensus
          mechanisms of POS public blockchains. All risks arising from or in
          connection to the POS public blockchains themselves are out of the
          control of Wepos, such as system failures or inherent defects in the
          POS public blockchains, lack of maintenance, or the ambiguity of
          indications from the POS public blockchains etc. Therefore, Wepos
          shall be exempted from assuming all and any liabilities and losses
          caused by the POS public blockchains.
          <br />
          <br />
          9. Misconduct of Users
          <br />
          <br />
          You shall be careful and cautious in the use of the Application or
          Service and you must be responsible for all actions and activities
          carried out by yourself or under your wallet address. You clearly
          understand that any missending or loss of digital assets caused by
          your personal carelessness or misconduct is irrevocable, unrecoverable
          and irreversible. Wepos has no capacity and no obligation to retrieve
          any lost digital assets for you.
          <br />
          <br />
           Scope of Responsibility and Limitation of Liability  <br />
          <br />
          1. Wepos will provide the Services to you on an as is" and "as
          available" basis. However, Wepos does not make any express or implied
          warranties in relation to the Service, including but not limited to
          the suitability of the Services, the Service contain no errors or
          omissions, and durability, accuracy, reliability, and fitness for a
          particular purpose of the Service. Wepos does not make any
          undertakings or guarantees regarding the validity, accuracy,
          correctness, reliability, quality, stability, completeness and
          timeliness of the technology and information related to the Service. 
          <br />
          <br />
          2. To the maximum extent permitted by law, in no event shall we be
          liable for any direct and indirect loss, damage or expense –
          irrespective of the manner in which it occurs – which may be suffered
          due to your use of our Application and Service and/or the information
          or materials contained on it, or as a result of the inaccessibility of
          the Application and Service and/or the fact that certain information
          or materials contained on it are incorrect, incomplete or not
          up-to-date.
          <br />
          <br />
          3. Without limiting the above, we will not be held liable for:
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(a) whether under contract law, torts
          law or otherwise, any business losses, loss of revenue, income,
          profits, opportunity or anticipated savings, loss of contracts or
          business relationships, loss of reputation or goodwill, and any other
          indirect, special or consequential loss.
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(b) any loss or damage caused by a
          virus, corruption of information or data, distributed
          denial-of-service attack, or other technologically harmful material
          that may infect your computer equipment, computer programs, data or
          other proprietary material due to your use of our Application and
          Service or to your downloading of any content on it, or on any website
          linked to it.
          <br />
          <br />
          4. These limitations of liability apply even if a loss was
          foreseeable, or if we have been expressly advised of the potential
          loss.
          <br />
          <br />
          5. Nothing in this Agreement excludes or limits the liability of any
          party for fraud, death or personal injury caused by its negligence,
          breach of terms and conditions implied by operation of law, or any
          other liability which may not by law be limited or excluded.
          <br />
          <br />
          6. Subject to the foregoing, our aggregate liability in respect of
          claims based on events arising out of or in connection with your use
          of the Application and Service, whether in contract or tortor
          otherwise (including negligence), shall in no circumstances exceed the
          earnings we made from user who is making a claim.
          <br />
          <br />
          Intellectual Property Rights <br />
          <br />
          1. Unless otherwise indicated, we own or license from third parties
          all rights, title and interest (including copyright, designs, patents,
          trademarks and other intellectual property rights) in all of the
          material (including all text, graphics, logos, audio and software)
          (“Content”) made available by us.
          <br />
          <br />
          2. Your use of the Application and Service and use of and access to
          any Content does not grant or transfer any rights, title or interest
          to you in relation to the Application or Service or the Content.
          However, we do grant you a license to access the Application or
          Service and view the Content on the relevant terms and conditions and,
          where applicable, as expressly authorized by us and/or our third party
          licensors.
          <br />
          <br />
          3. Any reduplication or redistribution of the Application or Service
          or the Content is prohibited and may result in civil and criminal
          penalties. In addition, you must not copy the Content to any other
          server, location or support for publication, and any reduplication or
          distribution is expressly prohibited.
          <br />
          <br />
          4. All other use, copying or reduplication of the Application or
          Service, the Content or any part of it is prohibited, except to the
          extent permitted by law. <br />
          <br />
          Termination
          <br />
          <br />
          1. You agree that Wepos has the right and full discretion and for any
          reason without prior notice to suspend or terminate part of or all of
          your use of the Application and Service, and will not be liable to you
          or any third party. 
          <br />
          <br />
          2. Wepos has the right to terminate this Agreement in the following
          circumstances:
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(a) The email address you have provided
          does not exist or is unable to receive emails, and there are no other
          ways to contact you, or Wepos notifies you through other means to
          change your email information but you have not changed your email to a
          valid email address within three (3) working days of our notification;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(b) Core personal information you have
          provided is untrue, inaccurate, outdated or incomplete;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(c) This Agreement (including the
          Relevant Rules) has been revised, and you express and notify Wepos
          that you are not willing to accept such terms and conditions or the
          Relevant Rules; and
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(d) Any other circumstances where Wepos
          believes that your use of the Application and Service should be
          terminated. 
          <br />
          <br />
          3. Wepos has no obligation to retain or disclose or forward to you or
          any third party any information during your use of Application or
          Service after this Agreement has been terminated or we suspend or
          terminate your use of the Application and Service.
          <br />
          <br />
          4. You agree that after you and Wepos’s contractual relationship has
          been terminated, Wepos still enjoys the following rights:
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(a) To save your personal information
          and all transaction information generated during your use of the
          Application and Service;
          <br />
          <br /> &nbsp;&nbsp;&nbsp;&nbsp;(b) If you have committed an illegal
          act or a breach of this Agreement and/or the Relevant Rules during
          your use of the Application and Service, Wepos may still makes claim
          against you in accordance with this Agreement. 
          <br />
          <br />
          Privacy Policy
          <br />
          <br />
          Wepos will publish our privacy policy on the Application, and may
          revise it from time to time. The privacy policy constitutes an
          effective part of this Agreement.
          <br />
          <br />
          Applicable Law and Dispute Resolution 
          <br />
          <br />
          This Agreement shall be governed by and construed in accordance with
          the laws of the Republic of Singapore and any conflicting legal rules
          or principles of Singapore will not be applicable. The remedies
          afforded by the laws are in addition to the remedies set out in this
          agreement. Any dispute arising out of or in connection with this
          Agreement, including any question regarding its existence, validity or
          termination, shall be referred to and finally resolved by arbitration
          in Singapore International Arbitration Centre (“SIAC”) in accordance
          with the Arbitration Rules of the SIAC ("SIAC Rules") for the time
          being in force, which rules are deemed to be incorporated by reference
          in this clause.
        </Typography>
      </Box>
    </Box>
  );
};
